
export const Types = {
    Team: 'team',
    User: 'user',
    Api: 'api',
    Worker: 'worker',
    All: 'all'
}
export const typeText = {
    [Types.Team]: 'Team',
    [Types.User]: 'User',
    [Types.Api]: 'External Api',
    [Types.Worker]: 'Worker',
    [Types.All]: 'All'
};